import { registerPlugin } from '@capacitor/core';
const CapacitorLan = registerPlugin('CapacitorLan', {
    web: () => import('./web').then(m => new m.CapacitorLanWeb()),
});
export * from './definitions';
export { CapacitorLan };
//# sourceMappingURL=index.js.map